import React from "react";
import { Button } from "./buttons"
import Modal from "./modal/Modal";

function ConfirmModal({ openModal, setOpenModal, onConfirm, setHasChanged }) {
  return (
    <Modal size="md" show={openModal} onClose={() => {setOpenModal(false); if (setHasChanged) setHasChanged(true)}}>
      <Modal.Header>
        このページから離れてもよろしいですか？
      </Modal.Header>
      <Modal.Body>
        <p>このページでいくつかの変更を行いましたが、まだ完了していません。このページを離れると、すべての変更が失われます。</p>
        <p className="mt-2">本当にページを離れますか？</p>
      </Modal.Body>
      <Modal.Footer className="justify-center space-x-[20px]">
        <Button color="light" className="min-w-[180px]"
          onClick={() => {setOpenModal(false); if (setHasChanged) setHasChanged(true)}}
          children="ページにとどまる"
        />
        <Button color="primary" className="min-w-[180px]" onClick={onConfirm} children="ページを離れる"/>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
